import React, { ReactElement } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import './mpkCancelButtons.scss';
import { BackButton, ConfirmModal } from 'slovlex-idsk-react-components';

interface Props {
  onClick: () => void;
  loading: boolean;
  isAktEu: boolean;
  isAdmin: boolean;
}

const MpkCancelButtons = ({
  onClick,
  loading,
  isAktEu,
  isAdmin,
}: Props): ReactElement => {
  const getDescription = (): string => {
    if (isAdmin) {
      return `Po vykonaní tejto funkcionality bude ukončené štádium "Pripomienkové konanie".
      K materiálu nebudú môcť používatelia pridávať ďalšie pripomienky, budú odoslané notifikácie 
      o zrušení pripomienkového konania a aktuálne štádium materiálu sa zmení na ${
  isAktEu ? '"Zápis predbežného stanoviska k návrhu aktu EÚ".' : '"Príprava materiálu".'
}`;
    }
    return `Po vykonaní tohto pracovného kroku bude ukončené štádium "Pripomienkové konanie".
      K materiálu nebude možné pridávať ďalšie pripomienky, budú odoslané notifikácie 
      o zrušení pripomienkového konania a aktuálne štádium materiálu sa zmení na ${
  isAktEu ? '"Zápis predbežného stanoviska k návrhu aktu EÚ".' : '"Príprava materiálu".'
}`;
  };
  return (
    <div className="cancel-mpk-buttons">
      <ConfirmModal
        question='Naozaj si prajete zrušiť štádium "Pripomienkové konanie"?'
        description={getDescription()}
        cancelButtonText="Nie"
        confirmButton={
        (
          <Button
            buttonStyle="action"
            size="large"
          >
            Áno
          </Button>
        )
      }
        openButton={(
          <LoaderButton
            className="cancel-mpk-button"
            loading={loading}
            size="large"
            disableOutsideClickWhileLoading
          >Zrušiť Pripomienkové konanie
          </LoaderButton>
      )}
        doAfterConfirm={onClick}
      />
      <BackButton disabled={loading} />
    </div>
  );
};
export default MpkCancelButtons;
